import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Soul.scss";
import arrow from "../../../assets/arrow.png";
import { useState } from "react";
import Footer from "../../../components/Footer/Footer";
import { Link } from "react-router-dom";
import axios from "axios";



export const destinyProfiles = {
    1: {
        title: "Soul Urge Number 1 – The Inner Leader",
        keywords: "Independence · Ambition · Self-worth",
        overview:
            "Soul Urge Number 1 reveals a deep inner desire to be independent, strong and self-reliant. You feel happiest when leading your own life without interference.",
        strengths: [
            "Strong inner drive",
            "Desire for achievement",
            "Self-respect and confidence",
            "Motivated from within"
        ],
        challenges: [
            "Ego sensitivity",
            "Fear of being controlled",
            "Difficulty accepting help"
        ],
        guidance:
            "True strength comes from confidence balanced with humility and cooperation."
    },

    2: {
        title: "Soul Urge Number 2 – The Emotional Harmoniser",
        keywords: "Love · Peace · Emotional security",
        overview:
            "Soul Urge Number 2 reflects a deep emotional need for love, harmony and close relationships. You crave emotional safety and togetherness.",
        strengths: [
            "Empathy and emotional intelligence",
            "Supportive and caring nature",
            "Natural peacemaker"
        ],
        challenges: [
            "Emotional dependence",
            "Fear of rejection",
            "Over-sensitivity"
        ],
        guidance:
            "Build inner confidence. Healthy relationships start with self-love."
    },

    3: {
        title: "Soul Urge Number 3 – The Joy Seeker",
        keywords: "Expression · Happiness · Creativity",
        overview:
            "Soul Urge Number 3 reveals a deep desire for joy, self-expression and appreciation. You feel fulfilled when expressing your thoughts and creativity.",
        strengths: [
            "Creative imagination",
            "Emotional expressiveness",
            "Natural optimism"
        ],
        challenges: [
            "Emotional inconsistency",
            "Need for validation",
            "Avoiding emotional depth"
        ],
        guidance:
            "Express freely, but anchor your emotions with discipline and purpose."
    },

    4: {
        title: "Soul Urge Number 4 – The Security Seeker",
        keywords: "Stability · Order · Trust",
        overview:
            "Soul Urge Number 4 reflects a deep need for stability, structure and reliability. You feel emotionally safe when life is organised and predictable.",
        strengths: [
            "Strong sense of responsibility",
            "Emotional loyalty",
            "Dependable inner nature"
        ],
        challenges: [
            "Fear of change",
            "Emotional rigidity",
            "Difficulty adapting"
        ],
        guidance:
            "Security grows stronger when flexibility is allowed alongside discipline."
    },

    5: {
        title: "Soul Urge Number 5 – The Freedom Lover",
        keywords: "Freedom · Variety · Experience",
        overview:
            "Soul Urge Number 5 shows a deep emotional need for freedom, movement and new experiences. Routine feels emotionally suffocating to you.",
        strengths: [
            "Adaptable emotions",
            "Curious and adventurous spirit",
            "Quick emotional recovery"
        ],
        challenges: [
            "Restlessness",
            "Emotional inconsistency",
            "Difficulty with commitment"
        ],
        guidance:
            "Freedom becomes fulfilling when guided by emotional awareness and responsibility."
    },

    6: {
        title: "Soul Urge Number 6 – The Loving Heart",
        keywords: "Care · Responsibility · Emotional bonds",
        overview:
            "Soul Urge Number 6 reflects a deep emotional desire to love, care and protect. You feel fulfilled when supporting family and loved ones.",
        strengths: [
            "Deep emotional bonding",
            "Nurturing heart",
            "Sense of duty and care"
        ],
        challenges: [
            "Over-giving",
            "Emotional burden",
            "Expecting appreciation"
        ],
        guidance:
            "Love others, but never forget to love yourself equally."
    },

    7: {
        title: "Soul Urge Number 7 – The Inner Seeker",
        keywords: "Truth · Depth · Spiritual connection",
        overview:
            "Soul Urge Number 7 reveals a deep inner longing for truth, solitude and spiritual understanding. You seek meaning beyond surface emotions.",
        strengths: [
            "Strong intuition",
            "Inner wisdom",
            "Spiritual inclination"
        ],
        challenges: [
            "Emotional withdrawal",
            "Isolation",
            "Difficulty expressing feelings"
        ],
        guidance:
            "Share your inner world. Emotional connection deepens wisdom."
    },

    8: {
        title: "Soul Urge Number 8 – The Power Seeker",
        keywords: "Achievement · Control · Recognition",
        overview:
            "Soul Urge Number 8 reflects a deep emotional desire for success, authority and recognition. You feel secure when you are in control of your life.",
        strengths: [
            "Strong emotional willpower",
            "Inner ambition",
            "Desire for material stability"
        ],
        challenges: [
            "Fear of failure",
            "Emotional stress",
            "Control issues"
        ],
        guidance:
            "True power comes when ambition is balanced with emotional wisdom."
    },

    9: {
        title: "Soul Urge Number 9 – The Compassionate Soul",
        keywords: "Compassion · Forgiveness · Emotional depth",
        overview:
            "Soul Urge Number 9 reveals a deeply compassionate heart. You feel emotionally fulfilled when helping, healing and uplifting others.",
        strengths: [
            "Emotional generosity",
            "Empathy and kindness",
            "Artistic sensitivity"
        ],
        challenges: [
            "Emotional overwhelm",
            "Difficulty letting go",
            "Self-sacrifice"
        ],
        guidance:
            "Release emotional baggage. Compassion must include self-care."
    },

    11: {
        title: "Soul Urge Number 11 – The Spiritual Heart",
        keywords: "Intuition · Sensitivity · Inspiration",
        overview:
            "Soul Urge Number 11 is a Master Number reflecting intense emotional sensitivity and spiritual awareness. You deeply desire meaning and purpose.",
        strengths: [
            "Heightened intuition",
            "Inspirational emotional presence",
            "Spiritual insight"
        ],
        challenges: [
            "Anxiety",
            "Emotional overload",
            "Self-doubt"
        ],
        guidance:
            "Ground your emotions. Your sensitivity is a spiritual gift."
    },

    22: {
        title: "Soul Urge Number 22 – The Responsible Visionary",
        keywords: "Purpose · Stability · Inner strength",
        overview:
            "Soul Urge Number 22 reveals a deep emotional desire to create something meaningful and lasting. You seek fulfillment through responsibility and impact.",
        strengths: [
            "Inner discipline",
            "Emotional maturity",
            "Vision with practicality"
        ],
        challenges: [
            "Pressure from expectations",
            "Fear of emotional failure",
            "Over-responsibility"
        ],
        guidance:
            "Build steadily. Emotional balance fuels lasting achievement."
    },
};


const Soul = () => {

    const [formData, setFormData] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        year: "2000",
        month: "May",
        day: "26",
        gender: "male" // ✅ DEFAULT, NO UI
    });


    const [resultData, setResultData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showReport, setShowReport] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { firstName, lastName, year, month, day } = formData;
        const birthDay = Number(day);
        const birthMonth = new Date(`${month} 1, 2000`).getMonth() + 1;
        const birthYear = Number(year);

        try {
            setLoading(true);

            const { gender } = formData;

            const res = await axios.get(
                `https://core-c343.onrender.com/api/lucky-number` +
                `?firstName=${firstName}` +
                `&lastName=${lastName}` +
                `&birthYear=${birthYear}` +
                `&birthMonth=${birthMonth}` +
                `&birthDay=${birthDay}` +
                `&gender=${gender}`
            );


            setResultData(res.data);
            setShowReport(true);
        } catch (err) {
            setResultData({
                error: "Unable to generate your Destiny Number report. Please try again.",
            });
            setShowReport(true);
        } finally {
            setLoading(false);
        }
    };

    const handleTryAgain = () => {
        setShowReport(false);
        setResultData(null);
    };

    const destinyNum = resultData?.data?.numerology?.soulUrgeNumber;
    const profile = destinyNum ? destinyProfiles[destinyNum] : null;

    return (
        <div className="destiny-container">
            <InnerNav />

            <div className="destiny-content">
                <Zodiac />

                <div className="left-numerology">

                    {/* FORM VIEW */}
                    {!showReport && (
                        <>
                            <div className="header">
                                <h1>Soul Urge Number Calculator</h1>
                                <p>
                                    Enter your name to discover your <strong>inner desires, emotional needs, and what truly fulfils your soul</strong>.
                                </p>
                            </div>


                            <div className="form-card">
                                <form onSubmit={handleSubmit} className="form-grid">

                                    <input
                                        name="firstName"
                                        placeholder="First Name"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                    />

                                    <input
                                        name="middleName"
                                        placeholder="Middle Name (Optional)"
                                        value={formData.middleName}
                                        onChange={handleChange}
                                    />

                                    <input
                                        name="lastName"
                                        placeholder="Last Name"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                    />

                                    <div className="dob-grid">
                                        <select name="day" value={formData.day} onChange={handleChange}>
                                            {[...Array(31)].map((_, i) => (
                                                <option key={i + 1}>{i + 1}</option>
                                            ))}
                                        </select>

                                        <select name="month" value={formData.month} onChange={handleChange}>
                                            {[
                                                "January", "February", "March", "April", "May", "June",
                                                "July", "August", "September", "October", "November", "December"
                                            ].map((m) => (
                                                <option key={m}>{m}</option>
                                            ))}
                                        </select>

                                        <select name="year" value={formData.year} onChange={handleChange}>
                                            {Array.from({ length: 110 }).map((_, i) => {
                                                const y = 2025 - i;
                                                return <option key={y}>{y}</option>;
                                            })}
                                        </select>
                                    </div>
                                    <select
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="other">Other</option>
                                    </select>


                                    <button type="submit" className="primary-btn" disabled={loading}>
                                        {loading ? "Generating..." : "Show My Destiny Number"}
                                    </button>

                                </form>
                            </div>
                        </>
                    )}

                    {/* REPORT VIEW */}
                    {showReport && (
                        <div className="report-card">

                            <h1>Your Soul Urge Number Report</h1>

                            {resultData?.error ? (
                                <p className="error-text">{resultData.error}</p>
                            ) : (
                                <>
                                    <div className="hero-number-box">
                                        <div className="number-circle">{destinyNum}</div>
                                        <h2>{profile?.title}</h2>
                                        <p className="keywords">{profile?.keywords}</p>
                                    </div>

                                    <div className="report-section">
                                        <h3>Overview</h3>
                                        <p>{profile?.overview}</p>
                                    </div>

                                    <div className="report-section">
                                        <h3>Your Strengths</h3>
                                        <ul>{profile?.strengths.map((s, i) => <li key={i}>{s}</li>)}</ul>
                                    </div>

                                    <div className="report-section">
                                        <h3>Your Challenges</h3>
                                        <ul>{profile?.challenges.map((c, i) => <li key={i}>{c}</li>)}</ul>
                                    </div>

                                    <div className="report-section">
                                        <h3>Guidance</h3>
                                        <p>{profile?.guidance}</p>
                                    </div>
                                </>
                            )}

                            <button className="try-again-btn" onClick={handleTryAgain}>
                                Try Again
                            </button>
                        </div>
                    )}
                </div>

                {/* RIGHT SIDEBAR */}
                <div className="right-numerology">
                    <h4>Related Links</h4>
                    <div className="right-links">
                        <Link to="/numerology/luckynum"><p><img src={arrow} /> Lucky Number</p></Link>
                        <Link to="/numerology/chinese-lucky"><p><img src={arrow} /> Chinese Lucky</p></Link>
                        <Link to="/numerology/unlucky"><p><img src={arrow} /> Unlucky Number</p></Link>
                        <Link to="/numerology/life-path"><p><img src={arrow} /> Life Path</p></Link>
                        <Link to="/numerology/destiny"><p><img src={arrow} /> Destiny Number</p></Link>
                        <Link to="/numerology/birth"><p><img src={arrow} /> Birth or Root Number</p></Link>
                        <Link to="/numerology/soul"><p><img src={arrow} /> Soul Urge Number</p></Link>
                        <Link to="/numerology/name"><p><img src={arrow} /> Name Number</p></Link>
                        <Link to="/numerology/balance"><p><img src={arrow} /> Balance Number</p></Link>
                        <Link to="/numerology/lo-shu-grid"><p><img src={arrow} /> Lo Shu Grid Analysis</p></Link>
                        <Link to="/numerology/kua"><p><img src={arrow} /> Kua Number</p></Link>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Soul;